import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { isEmptyString } from '../helper/utils';

function appController($rootScope, $mdSidenav, $mdBottomSheet, $log, $q, $sce, $mdMedia, $state, $mdDialog, Canvas, Auth) {
  'ngInject';

  let originatorEv;
  let _t_unloadMessage = 'Möchtest du den Layoutgenerator wirklich verlassen?';

  $rootScope.log = function(message) {
    if(!window.defaults.isLoggingEnabled) return;

    console.log(message);
  };

  ///////////////////////////
  // <start> Configuration //
  ///////////////////////////
  $rootScope.exportFileExtension = '.komlayout';
  $rootScope.supportedImageFormats = [{ mime: 'image/png', name: 'PNG' }, { mime: 'image/jpeg', name: 'JPEG' }];

  $rootScope.mainMenu = {
    items: [
      {
        state: 'app.welcome',
        title: 'Einführung',
        icon: '&#xE037;'
      },
      {
        state: 'app.canvas.toolset-basic-layout',
        title: 'Basislayout',
        icon: '&#xE8F1;'
      },
      {
        state: 'app.canvas.toolset-background',
        title: 'Hintergrund',
        icon: '&#xE40A;'
      },
      {
        state: 'app.canvas.toolset-border',
        title: 'Fotorahmen',
        icon: '&#xE40F;'
      },
      {
        state: 'app.canvas.toolset-images',
        title: 'Logos & Grafiken',
        icon: '&#xE439;'
      },
      {
        state: 'app.canvas.toolset-shapes',
        title: 'Formen',
        icon: 'crop_16_9'
      },
      {
        state: 'app.canvas.toolset-text',
        title: 'Text',
        icon: '&#xE25E;'
      }
    ],
    selectedItem: ''
  };

  $rootScope.currentAccount = {};
  $rootScope.toolbarConf = {
    isOpenSupported: false,
    isSaveSupported: false,
    isExportSupported: false
  };

  Auth.getCurrentUser(user => {
    const diff = moment(user.expiryDate).diff(moment());
    const duration = moment.duration(diff);
    const days = duration.asDays();
    const hours = duration.hours();
    const minutes = duration.minutes() + 1;
    let countDown = [];

    if(diff < 0) countDown.push('Abgelaufen');
    else {
      if(days > 1) countDown.push(`${Math.floor(days)} ${days >= 2 ? 'Tage' : 'Tag'}`);
      if(hours > 0) countDown.push(`${hours} ${hours > 1 ? 'Stunden' : 'Stunde'}`);
      if(minutes > 0) countDown.push(`${minutes} ${minutes > 1 ? 'Minuten' : 'Minute'}`);
    }

    $rootScope.currentAccount = {
      expiryDate: user.expiryDate,
      expiryDateDifferenceFromNowInDays: countDown.join(', '),
      role: user.role
    };

    $rootScope.toolbarConf = {
      isOpenSupported: user.role !== 'demo',
      isSaveSupported: true,
      isExportSupported: user.role !== 'demo'
    };

    if(user.role !== 'demo') {
      if(!$rootScope.mainMenu.items.find(item => item.state === 'app.canvas.toolset-finish')) {
        $rootScope.mainMenu.items.push({
          state: 'app.canvas.toolset-finish',
          title: 'Abschicken',
          icon: '&#xE2C3;'
        });
      }
    }

    if(user.role === 'admin') {
      if(!$rootScope.mainMenu.items.find(item => item.state === 'admin')) {
        $rootScope.mainMenu.items.push({
          state: 'admin',
          title: 'Admin',
          icon: '&#xE8B8;'
        });
      }
    }
  });

  ///////////////////////////
  // </end> Configuration  //
  ///////////////////////////

  window.CanvasService = Canvas;
  $rootScope.$mdMedia = $mdMedia;
  $rootScope.mainMenu.selectedItem = $rootScope.mainMenu.items[0].state;

  let imageFormatsEscaped = [];
  $.each($rootScope.supportedImageFormats, function(index, value) {
    imageFormatsEscaped.push(value.mime);
  });
  $rootScope.supportedImageFormats.acceptString = imageFormatsEscaped.join(',');
  $rootScope.log('Supported image formats: ' + $rootScope.supportedImageFormats.acceptString);

  $rootScope.safeApply = function(fn) {
    let phase = this.$root.$$phase;
    if(phase == '$apply' || phase == '$digest') {
      if(fn && typeof fn === 'function') {
        fn();
      }
    } else {
      this.$apply(fn);
    }
  };

  $rootScope.prepareStateChange = function() {
    $mdSidenav('left').close();
  };

  $rootScope.toggleMainMenu = function() {
    $rootScope.log('Invoke: toggleMainMenu');
    $mdSidenav('left').toggle();
  };

  $rootScope.openMenu = function($mdOpenMenu, ev) {
    originatorEv = ev;
    $mdOpenMenu(ev);
  };

  $rootScope.selectMainMenuItem = function(selector) {
    let handler = function() {
      $rootScope.prepareStateChange();
      $rootScope.mainMenu.selectedItem = selector;
      return $state.go(selector);
    };

    if($rootScope.mainMenu.selectedItem.indexOf('canvas') != -1 && Canvas.getIsDirty() && selector.indexOf('canvas') == -1) {
      if(confirm(_t_unloadMessage)) {
        return handler();
      }
    } else {
      return handler();
    }
  };

  $rootScope.getSelectedMenuItemTitle = function() {
    let items = $.grep($rootScope.mainMenu.items, function(e) {
      return e.state === $rootScope.mainMenu.selectedItem;
    });
    let item = items[0];
    return item.title;
  };

  $rootScope.fastNavCanGoBack = function() {
    let items = $.grep($rootScope.mainMenu.items, function(e) {
      return e.state === $rootScope.mainMenu.selectedItem;
    });
    let current = items[0];
    let index = $rootScope.mainMenu.items.indexOf(current);
    return index > 0;
  };

  $rootScope.fastNavCanGoForward = function() {
    let items = $.grep($rootScope.mainMenu.items, function(e) {
      return e.state === $rootScope.mainMenu.selectedItem;
    });
    let current = items[0];
    let index = $rootScope.mainMenu.items.indexOf(current);
    return index < $rootScope.mainMenu.items.length - 1;
  };

  $rootScope.fastNavGoBack = function() {
    if(!$rootScope.fastNavCanGoBack()) return;

    let items = $.grep($rootScope.mainMenu.items, function(e) {
      return e.state === $rootScope.mainMenu.selectedItem;
    });
    let current = items[0];
    let index = $rootScope.mainMenu.items.indexOf(current);
    let newIndex = index - 1;
    $rootScope.selectMainMenuItem($rootScope.mainMenu.items[newIndex].state);
  };

  $rootScope.fastNavGoForward = function() {
    if(!$rootScope.fastNavCanGoForward()) return;

    let items = $.grep($rootScope.mainMenu.items, function(e) {
      return e.state === $rootScope.mainMenu.selectedItem;
    });
    let current = items[0];
    let index = $rootScope.mainMenu.items.indexOf(current);
    let newIndex = index + 1;
    $rootScope.selectMainMenuItem($rootScope.mainMenu.items[newIndex].state);
  };

  $rootScope.fileUploadRejected = function() {
    $mdDialog.show(
      $mdDialog
        .alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .title('Nicht unterstützt')
        .textContent('Diese Datei wird nicht unterstützt.')
        .ariaLabel('')
        .ok('Ok')
    );
  };

  $rootScope.loadingOverlay = function() {
    $mdDialog.show({
      controller: ['$rootScope', '$mdDialog', function(scope, mdDialog) {}],
      template: '<div layout="row" layout-align="space-around"><md-progress-linear md-mode="indeterminate"></md-progress-linear></div>',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      fullscreen: false
    });
  };

  $rootScope.openCanvasSavedFile = function(file, invalidFiles) {
    if(invalidFiles.length > 0) {
      $rootScope.fileUploadRejected();
      return;
    }

    if(file == null) return;

    let loadFile = function() {
      try {
        $rootScope.loadingOverlay();

        let reader = new FileReader();
        reader.onload = (function(theFile) {
          return function(e) {
            try {
              let fileSource = e.target.result;
              let json = atob(fileSource);

              Canvas.loadCanvasFromJson(json, function() {
                $mdDialog.hide();
              });
            } catch(e) {
              $rootScope.log(e);
              $rootScope.fileUploadRejected();
            }
          };
        })(file);

        reader.readAsText(file);
      } catch(e) {
        $rootScope.log(e);
      }
    };

    if(!window.globalStageInstance) {
      Canvas.stageInitialized(loadFile);
      $rootScope.selectMainMenuItem('app.canvas.toolset-basic-layout');
    } else {
      $rootScope.selectMainMenuItem('app.canvas.toolset-basic-layout');
      loadFile();
    }
  };

  $rootScope.saveCanvasFile = function() {
    const user = Auth.getCurrentUserSync();

    if(!Canvas.getIsDirty()) {
      $mdDialog.show(
        $mdDialog
          .alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Achtung')
          .textContent('Bitte wähle zuerst ein Layout aus.')
          .ok('Ok')
      );
      return;
    }

    let json = Canvas.saveCanvasToJson();
    let blob = new Blob([btoa(json)], { type: 'application/octet-stream' }); //text/plain;charset=utf-8
    const eventDate = moment(user.eventDate);
    saveAs(blob, `${user.name} ${eventDate.isValid() ? eventDate.format('DD-MM-YYYY') : ''} ID ${user.eventId || 0}` + $rootScope.exportFileExtension);
  };

  $rootScope.exportCanvas = function() {
    const user = Auth.getCurrentUserSync();

    if(!Canvas.getIsDirty()) {
      $mdDialog.show(
        $mdDialog
          .alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Achtung')
          .textContent('Bitte wähle zuerst ein Layout aus.')
          .ok('Ok')
      );
      return;
    }

    Canvas.serializeCanvas(true, function(blob) {
      const eventDate = moment(user.eventDate);
      saveAs(blob, `${user.name} ${eventDate.isValid() ? eventDate.format('DD-MM-YYYY') : ''} ID ${user.eventId || 0}` + '.png');
    });
  };

  window.onbeforeunload = function() {
    if(Canvas.getIsDirty()) {
      return _t_unloadMessage;
    }

    return;
  };

  $rootScope.$on('$viewContentLoaded', function(event, next, current) {
    $rootScope.log($state.current.name + ' isEmpty: ' + isEmptyString($state.current.name));
    let appStartState = $state.current.name;

    if(!isEmptyString(appStartState)) {
      let isStateAvailable = false;

      for(let i = 0; i < $rootScope.mainMenu.items.length; i++) {
        if(appStartState === $rootScope.mainMenu.items[i].state) {
          isStateAvailable = true;
          return;
        }
      }

      if(!isStateAvailable) {
        return;
      }

      $state.go(appStartState);
      $rootScope.mainMenu.selectedItem = appStartState;
    }
  });
}

export default angular
  .module('directives.app', [])
  .config(function($stateProvider) {
    'ngInject';

    $stateProvider.state('app', {
      abstract: true,
      controller: 'AppController',
      template: '<ui-view/>'
    });
  })
  .controller('AppController', appController).name;



// WEBPACK FOOTER //
// ./client/app/app.controller.js